import { render, staticRenderFns } from "./team-form.vue?vue&type=template&id=ca61a826&scoped=true&"
import script from "./team-form.vue?vue&type=script&lang=js&"
export * from "./team-form.vue?vue&type=script&lang=js&"
import style0 from "./team-form.vue?vue&type=style&index=0&id=ca61a826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca61a826",
  null
  
)

component.options.__file = "team-form.vue"
export default component.exports